// extracted by mini-css-extract-plugin
module.exports = {"header":"BroadcastNoteModal_header__sjz3M","content":"BroadcastNoteModal_content__2elIw","actions":"BroadcastNoteModal_actions__1unmR"};